import React from 'react';
import { View } from '@fairygodboss/ui';

const NoCommentSVG = () => (
    <svg
        width="501"
        height="216"
        viewBox="0 0 501 216"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_d_403_60292)">
            <path
                d="M32 32C32 25.3726 37.3726 20 44 20H357C363.627 20 369 25.3726 369 32V96C369 102.627 363.627 108 357 108H44C37.3726 108 32 102.627 32 96V32Z"
                fill="white"
            />
            <rect
                x="120"
                y="40"
                width="229"
                height="16"
                rx="3"
                fill="#C4CBD8"
            />
            <rect
                x="120"
                y="72"
                width="169"
                height="16"
                rx="3"
                fill="#E9ECF1"
            />
            <circle cx="76" cy="64" r="24" fill="#9DA9BF" />
            <circle
                cx="76"
                cy="64"
                r="18"
                fill="#E9ECF1"
                stroke="white"
                strokeWidth="4"
            />
        </g>
        <g filter="url(#filter1_d_403_60292)">
            <path
                d="M132 96C132 89.3726 137.373 84 144 84H457C463.627 84 469 89.3726 469 96V160C469 166.627 463.627 172 457 172H144C137.373 172 132 166.627 132 160V96Z"
                fill="white"
            />
            <rect
                x="220"
                y="104"
                width="229"
                height="16"
                rx="3"
                fill="#C4CBD8"
            />
            <rect
                x="220"
                y="136"
                width="169"
                height="16"
                rx="3"
                fill="#E9ECF1"
            />
            <circle cx="176" cy="128" r="24" fill="#9DA9BF" />
            <circle
                cx="176"
                cy="128"
                r="18"
                fill="#E9ECF1"
                stroke="white"
                strokeWidth="4"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_403_60292"
                x="0"
                y="0"
                width="401"
                height="152"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="12" />
                <feGaussianBlur stdDeviation="16" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0.24 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_403_60292"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_403_60292"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_403_60292"
                x="100"
                y="64"
                width="401"
                height="152"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="12" />
                <feGaussianBlur stdDeviation="16" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0.24 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_403_60292"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_403_60292"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
);

export const NoComments = () => (
    <View display="flex" justifyContent="center" pt="10px">
        <NoCommentSVG />
    </View>
);
